export const loadSVGSpritesheet = {
    onDocumentLoad
}

const onDocumentLoad = function() {
  var request = new XMLHttpRequest();
  request.open("GET", "/images/spritesheet.svg?v=2");
  request.send();
  request.onreadystatechange = function () {
    if (request.readyState == XMLHttpRequest.DONE) {
      if (request.status == 200) {
        var data = request.responseText;
        var svgContainer = document.getElementById("svg-icons");
        svgContainer.innerHTML = data;
      } else {
        console.error("Couldn't load SVG spritesheet");
      }
    }
  };
}